import * as GetProjectInterestedTypes from 'src/actions/project/interested/get/Types';
import {
  GetProjectInterestedAction,
  GetProjectInterestedSuccess
} from 'src/actions/project/interested/get/GetProjectInterested.actions';
import Person from 'src/entities/Person';

export interface GetProjectInterestedState {
  projectInterested?: Person[];
  interestedUser?: boolean;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetProjectInterestedState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetProjectInterestedReducer(
  state: GetProjectInterestedState = initialState,
  action: GetProjectInterestedAction
): GetProjectInterestedState {

  switch (action.type) {
    case GetProjectInterestedTypes.GET_PROJECT_INTERESTED_ATTEMPT:
      return {...state, projectInterested: undefined, interestedUser: undefined, loading: true, error: false};
    case GetProjectInterestedTypes.GET_PROJECT_INTERESTED_SUCCESS:
      const projectInterested: Person[] = (action as GetProjectInterestedSuccess).payload.projectInterested;
      const interestedUser = (action as GetProjectInterestedSuccess).payload.interestedUser;
      return {
        ...state,
        projectInterested: projectInterested,
        interestedUser: interestedUser,
        loading: false,
        error: false
      };
    case GetProjectInterestedTypes.GET_PROJECT_INTERESTED_FAILURE:
      return {...state, projectInterested: undefined, interestedUser: undefined, loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project/interested/GetProjectInterestedReducer.tsx